export default {
  'Tipe Pengguna': {
    category: 'User Profiling Page 1',
    action: 'Click "$var" option in User Profiling first page',
    label: 'Click_$var_Option_User_Profiling_Page1',
  },
  'Segmen Usaha': {
    category: 'User Profiling Page 2',
    action: 'Select "$var" in "MSME Type" field',
    label: 'Select_entry_MSME_Type_User_Profiling_Page2',
  },
  'Tipe Bisnis': {
    category: 'User Profiling Page 2',
    action: 'Select "$var" in "Business Type" field',
    label: 'Select_entry_Business_Type_User_Profiling_Page2',
  },
  'Bidang Usaha': {
    category: 'User Profiling Page 2',
    action: 'Select "$var" in "Business Fields" field',
    label: 'Select_entry_Business_Fields_User_Profiling_Page2',
  },
  'Badan Usaha': {
    category: 'User Profiling Page 2',
    action: 'Select "$var" in "Company Type" field',
    label: 'Select_entry_Company_Type_User_Profiling_Page2',
  },
  'Apakah Anda memiliki toko online?': {
    category: 'User Profiling Page 2',
    action: 'Select "$var" in Do You Have Online Store',
    label: 'Select_$var_Online_Store_User_Profiling_Page2',
  },
  'Kebutuhan Bisnis': {
    category: 'User Profiling Page 3',
    action: 'Select "$var" in User Profiling Page 3',
    label: 'Select_Categories_User_Profiling_Page3',
  },
  submit: {
    'Tipe Bisnis': {
      category: 'User Profiling Page 1',
      action: 'Click "Submit" in User Profiling first page',
      label: 'Click_Submit_User_Profiling_Page1',
    },
    'Kategori Kebutuhan': {
      category: 'User Profiling Page 3',
      action: 'Click "Submit" in User Profiling Page 3',
      label: 'Click_Submit_User_Profiling_Page3',
    },
  },
}
